import store from '@/store/vuex'
import { Module, VuexModule, Mutation, getModule } from "vuex-module-decorators";
import type { Promocao } from '@/models'

const PROMOCAO_STORAGE = 'PROMOCAO_STORAGE'

export interface DadosPromocaoSelecionada {
	promocoesSelecionadas: Promocao[]
	promoDescontos: Array<{ promocaoId: string; porcentagem: number }>
	tiposDePagamentoPermitidosPelaPromocao: string[]
}

const DEFAULT_STATE: DadosPromocaoSelecionada = {
	promocoesSelecionadas: [],
	promoDescontos: [],
	tiposDePagamentoPermitidosPelaPromocao: [],
}

function salvarNoLocalStorage(state: DadosPromocaoSelecionada) {
	localStorage.setItem(PROMOCAO_STORAGE, JSON.stringify(state))
}

function lerDoLocalStorage(): DadosPromocaoSelecionada {
	const raw = localStorage.getItem(PROMOCAO_STORAGE)
	return raw ? JSON.parse(raw) : DEFAULT_STATE
}

@Module({
	name: "PromocaoStore",
	namespaced: true,
	dynamic: true,
	store,
})
export default class PromocaoStore extends VuexModule {
	dados: DadosPromocaoSelecionada = lerDoLocalStorage()

	@Mutation
	setDados(parcial: Partial<DadosPromocaoSelecionada>) {
		this.dados = { ...this.dados, ...parcial }
		salvarNoLocalStorage(this.dados)
	}

	@Mutation
	resetar() {
		this.dados.promocoesSelecionadas = []
		this.dados.promoDescontos = []
		this.dados.tiposDePagamentoPermitidosPelaPromocao = []
		salvarNoLocalStorage(this.dados)
	}
}

export const PromocaoModule = getModule(PromocaoStore)
